import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import Card from '../../common/card/card'
import Typography from '../../common/typography/typography'
import './productCard.scss'
import ImageCard from '../imageCard/imageCard'

const { Text } = Typography

// Status codes mapping
const STATUS_MAP = {
  0: 'Live',
  3: 'Quit',
  4: 'Allocated',
  6: 'New Line',
  7: 'Supplier Return',
  8: 'Markdown'
}

const getStatusText = (code) => `${code} - ${STATUS_MAP[code] || 'Unspecified'}`

const ProductCard = ({ product, loadingSOH = false, className = '' }) => {
  const [imageKey, setImageKey] = useState(0)

  useEffect(() => {
    setImageKey(prev => prev + 1)
  }, [product.keycode, product.imageUrl])

  // Generate CSS class based on status
  const statusClass = `app-product-card--status-${product.status}`
  const cardClassName = `app-product-card ${statusClass} ${className}`.trim()

  return (
    <Card className={cardClassName}>
      <ImageCard
        key={imageKey}
        data={{
          imageUrl: product.imageUrl,
          imageIndex: product.keycode
        }}
      />

      <div className="app-product-card-price">
        <Text strong className="app-product-card-price-text">
          ₱ {product.price}
        </Text>
      </div>

      <div className="app-product-card-info">
        <InfoItem label="Description" value={product.description} />
        <InfoItem label="Department" value={product.department} />
        <InfoItem label="Keycode" value={product.keycode} />
        <InfoItem label="APN" value={product.apn} />
        <InfoItem label="Status" value={getStatusText(product.status)} />

        {loadingSOH ? (
          <div className="app-product-card-loading">
            <InfoItem label="DC SOH" value={<Spin size="small" />} />
            <InfoItem label="Store SOH" value={<Spin size="small" />} />
            <InfoItem label="In Transit" value={<Spin size="small" />} />
          </div>
        ) : (
          <>
            <InfoItem label="DC SOH" value={product.dcSOH ?? 'N/A'} />
            <InfoItem label="Store SOH" value={product.storeSOH ?? 'N/A'} />
            <InfoItem label="In Transit" value={product.inTransitQty ?? 'N/A'} />
          </>
        )}
      </div>
    </Card>
  )
}

const InfoItem = ({ label, value }) => (
  <div className="app-product-card-info-item">
    <Text strong>{label}:</Text> <Text>{value}</Text>
  </div>
)

InfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node
}

ProductCard.propTypes = {
  product: PropTypes.shape({
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    description: PropTypes.string.isRequired,
    department: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    keycode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    apn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    status: PropTypes.number.isRequired,
    dcSOH: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    storeSOH: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inTransitQty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    imageUrl: PropTypes.string
  }).isRequired,
  loadingSOH: PropTypes.bool,
  className: PropTypes.string
}

export default ProductCard